(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
      })();
      (function() {
  if (!__sections__["featured-blog"] && !window.DesignMode) return;
  try {
     
  const blogSlider = new Swiper('.featured-blog__mobile', {
    slidesPerView: 1.25,
    loop: true,
    spaceBetween: 20,
    speed: 600,
    breakpoints: {
      600: {
        slidesPerView: 1.6
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  const openSearch = document.querySelector('.js-open-search');
  const closeSearch = document.querySelector('.js-close-search');
  const search = document.querySelector('.header__search');

  openSearch.addEventListener('click', () => {
    if (search.classList.contains('is-visible')) {
      search.classList.remove('is-visible');
    } else {
      search.classList.add('is-visible');
    }
  });

  closeSearch.addEventListener('click', () => {
    search.classList.remove('is-visible');
  }); 

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["how-it-works"] && !window.DesignMode) return;
  try {
    
  // Text Parallax
  gsap.to('.how-it-works__bg-text', {
    yPercent: 35,
    ease: "none",
    scrollTrigger: {
      trigger: '.how-it-works',
      scrub: true
    }, 
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["legal-popup"]) return;
  try {
    
  const legalPopup = document.querySelector('.legal-popup');
  const legalPopupClose = document.querySelector('.legal-popup__close');

  if (getCookie('legalCookie')) {
    legalPopup.classList.remove('is-visible');
  } else {
    legalPopup.classList.add('is-visible');
  }

  legalPopupClose.addEventListener('click', event => {
    const day = legalPopup.dataset.day;

    legalPopup.classList.remove('is-visible');
    setCookie('legalCookie', true, day);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-404"]) return;
  try {
    
const main404 = document.querySelector('.main-404'); 
main404.addEventListener('mousemove', function(i) {
  if (window.innerWidth < 768) {
    return;
  } 
  
  var n = i.clientX / window.innerWidth - .5,
    a = i.clientY /  window.innerHeight - .5;

  gsap.to('.main-404__title', 1, {
    y: n * 10,
    x: a * 10,
    ease: Power1.easeOut
  });

  gsap.to('.main-404__star', 1, {
      y: n * 60,
      x: a * 60,
      rotate: a * 10,
      ease: Power1.easeOut
  });

  gsap.to('.main-404__scribble', 1, {
    x: n * 50,
    y: a * 90,
    rotate: a * 5,
    ease: Power1.easeOut
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog"]) return;
  try {
    
  const tagDropdown = document.querySelector('.blog__tags-select');
  tagDropdown.addEventListener('change', event => {
    const url = event.target.value;

    window.location.href = url;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  // Change bg colors
  const elsToChange = document.querySelectorAll('.bg-will-change');
  elsToChange.forEach(item => {
    item.style.backgroundColor = pdpColor;
  });

  // Main product slider
  const initialSlide = Number(document.querySelector('.product__media-list').dataset.initial) - 1;

  const productSlider = new Swiper('.product__media-list', {
    slidesPerView: 1.15,
    loop: true,
    spaceBetween: 10,
    centeredSlides: true,
    breakpoints: {
      769: {
        slidesPerView: 1,
        spaceBetween: 20
      }
    }
  });

  window.productSlider = productSlider;
  productSlider.slideToLoop(initialSlide);


  // Sync slider with thumbnails
  productSlider.on('slideChange', slider => {
    let idx = slider.realIndex;
    const activeThumb = document.querySelector('.product__media-thumbnail-item.active');
    const newThumb = document.querySelector(`.product__media-thumbnail-item[data-index="${idx}"]`);
    
    activeThumb.classList.remove('active');
    newThumb.classList.add('active');
  });

  // Sync thumbnails with slider
  const thumbnails = document.querySelectorAll('.product__media-thumbnail-item');
  thumbnails.forEach(thumbnail => {
    thumbnail.addEventListener('click', event => {
      let idx = Number(event.currentTarget.dataset.index);
  
      productSlider.slideToLoop(idx);
    });
  });

  // Display variant description
  
  

  // Product dropdowns
  const dropdownButtons = document.querySelectorAll('.product-dropdown__header');

  dropdownButtons.forEach(dropdownButton => {
    dropdownButton.addEventListener('click', event => {
      const parent = event.currentTarget.parentElement;
      const content = parent.querySelector('.product-dropdown__content');
      const activeDropdown = document.querySelector('.product-dropdown.active');

      if (!parent.classList.contains('active')) {
        if (activeDropdown) {
          const activeContent = activeDropdown.querySelector('.product-dropdown__content');

          activeDropdown.classList.remove('active');
          slideUp(activeContent, 100);
        }

        parent.classList.add('active');
        slideDown(content, 100);
      } else {
        parent.classList.remove('active');
        slideUp(content, 100);
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-video"] && !window.DesignMode) return;
  try {
    
  const playButton = document.querySelector('.pdp-video__container-play');
  const pdpVideo = document.querySelector('.pdp-video__container video');
  playButton.addEventListener('click', event => {
    playButton.classList.add('is-hidden');
    pdpVideo.play();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["press-slider"] && !window.DesignMode) return;
  try {
    
  const pressSlider = new Swiper('.press-slider__quote-slider', {
    slidesPerView: 1,
    loop: true,
    spaceBetween: 20,
    speed: 600,
    autoplay: {
      delay: 3000,
    },
    effect: 'fade'
  });

  const logoPressSlider = new Swiper('.press-slider__logo-slider', {
    slidesPerView: 2.5,
    loop: true,
    spaceBetween: 20,
    centeredSlides: true,
    speed: 600,
    slideToClickedSlide: true,
    autoplay: {
      delay: 3000,
    },
    breakpoints: {
      550: {
        slidesPerView: 3
      },
      850: {
        slidesPerView: 5
      }
    }
  });

  pressSlider.on('slideChange', slider => {
    let idx = slider.realIndex;
    
    logoPressSlider.slideToLoop(idx);
  });

  logoPressSlider.on('slideChange', slider => {
    let idx = slider.realIndex;
    
    pressSlider.slideToLoop(idx);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-feature"] && !window.DesignMode) return;
  try {
    
  const featureSlider = new Swiper('.product-feature__group', {
    loop: true,
    spaceBetween: 40,
    effect: 'fade',
    speed: 800,
    initialSlide: 2
  });

  const mobileFeatureSlider = new Swiper('.product-feature__mobile-group', {
    loop: true,
    spaceBetween: 40,
    effect: 'fade',
    speed: 800,
    initialSlide: 2
  });

  featureSlider.on('slideChange', slider => {
    let idx = slider.realIndex;
    
    mobileFeatureSlider.slideToLoop(idx);
  });

  // Handle navigation click
  const navItems = document.querySelectorAll('.product-feature__navigation-item');
  navItems.forEach(navItem => {
    navItem.addEventListener('click', event => {
      const idx = Number(navItem.dataset.idx);
      featureSlider.slideToLoop(idx);

      navItem.parentElement.querySelector('.product-feature__navigation-item.active').classList.remove('active');
      navItem.classList.add('active');

      document.querySelector('.product-feature__straw-container.active').classList.remove('active');
      document.querySelector(`.product-feature__straw-container[data-idx="${idx}"]`).classList.add('active');
    });
  }); 

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            const productSlider = new Swiper('.product-recommendations__grid', {
              slidesPerView: 1.15,
              loop: true,
              spaceBetween: 20,
              speed: 600,
              breakpoints: {
                450: {
                  slidesPerView: 1.2
                },
                651: {
                  slidesPerView: 1.5
                },
                768: {
                  slidesPerView: 2.5
                },
                1024: {
                  slidesPerView: 3
                }
              }
            });

          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-slider"] && !window.DesignMode) return;
  try {
     
  const productSlider = new Swiper('.product-slider__slider', {
    slidesPerView: 1.15,
    loop: true,
    spaceBetween: 20,
    speed: 600,
    navigation: {
      prevEl: '.product-slider .swiper-button-prev',
      nextEl: '.product-slider .swiper-button-next'
    },
    scrollbar: {
      el: '.product-slider__scrollbar',
      draggable: true
    },
    breakpoints: {
      450: {
        slidesPerView: 1.2
      },
      651: {
        slidesPerView: 1.5
      },
      768: {
        slidesPerView: 2.5
      },
      1024: {
        slidesPerView: 3.2
      },
      1280: {
        slidesPerView: 3.5
      },
      1440: {
        slidesPerView: 4.1
      },
      1550: {
        slidesPerView: 4.8
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-articles"] && !window.DesignMode) return;
  try {
    
  const relatedArticleSlider = new Swiper('.related-articles__grid', {
    slidesPerView: 1.25,
    loop: true,
    spaceBetween: 20,
    speed: 600,
    breakpoints: {
      769: {
        slidesPerView: 3,
        spaceBetween: 40
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["steps"] && !window.DesignMode) return;
  try {
    
  // Text Parallax
  gsap.to('.steps__bg-text', {
    yPercent: 85,
    ease: "none",
    scrollTrigger: {
      trigger: '.steps-sizes',
      scrub: true
    }, 
  }); 

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["story-header"]) return;
  try {
    
  /*
  let headerTL = gsap.timeline({
    ease: 'linear'
  });

  headerTL.to('.story-header__straw', {
    y: -135,
    x: 60,
    opacity: 1,
    stagger: 0.15,
    duration: 1
  }, '<+=.1')
  .to('.story-header__straw', {
    y: 0,
    x: 0,
    stagger: 0.15,
    duration: 1
  }, '<+=.22');

  const header = document.querySelector('.story-header'); 
  header.addEventListener('mousemove', function(i) {
    if (window.innerWidth < 768) {
      return;
    } 
    
    var n = i.clientX / window.innerWidth - .5,
      a = i.clientY /  window.innerHeight - .5;

    gsap.to('.story-header__container', 1, {
      y: n * 10,
      x: a * 10,
      ease: Power1.easeOut
    });

    gsap.to('.story-header__star', 1, {
      y: n * 70,
      x: a * 70,
      rotate: a * 10,
      ease: Power1.easeOut
    });

    gsap.to('.story-header__scribble', 1, {
      x: n * 50,
      y: a * 90,
      rotate: a * 5,
      ease: Power1.easeOut
    });

  });
  */

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["story-video"]) return;
  try {
    
  const playButton = document.querySelector('.story-video__container-play');
  const storyVideo = document.querySelector('.story-video__container video');
  playButton.addEventListener('click', event => {
    playButton.classList.add('is-hidden');
    storyVideo.play();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["straw-sizes"] && !window.DesignMode) return;
  try {
     
  const strawSlider = new Swiper('.straw-sizes__grid', {
    slidesPerView: 2.1, 
    loop: true,
    spaceBetween: 35,
    speed: 600,
    allowTouchMove: true,
    centeredSlides: true,
    scrollbar: {
      el: '.straw-size__scrollbar',
      draggable: true
    },
    breakpoints: {
      550: {
        slidesPerView: 2.8,
        spaceBetween: 20
      },
      650: {
        slidesPerView: 3.7,
        spaceBetween: 20
      },
      768: {
        slidesPerView: 5,
        centeredSlides: false,
        allowTouchMove: false,
        spaceBetween: 20
      }
    }
  });

  // Text Parallax
  gsap.to('.straw-sizes__bg-text', {
    yPercent: 35,
    ease: "none",
    scrollTrigger: {
      trigger: '.straw-sizes',
      scrub: true
    }, 
  });

  } catch(e) { console.error(e); }
})();
      })();
